(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/behaviors/about.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/behaviors/about.js');

'use strict';

svs.player_login.behaviors.About = Marionette.Behavior.extend({
  ui: {
    helpLink: '.js-help'
  },
  events: {
    'click @ui.helpLink': 'onHelpClick'
  },
  onHelpClick() {
    let template = svs.player_login.templates.about();
    if (this.view.model.get('isCustomerRegistration')) {
      template = svs.player_login.templates.aboutreg();
    }
    const dialog = new svs.ui.dialog.Confirm({
      branding: this.view.model.get('isPnp') ? svs.components.dialog.branding.MOMANG : svs.components.dialog.branding.SPORT,
      icon: 'help-2',
      title: "Verifiera dig med BankID eller Freja eID",
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: template
      }],
      actions: [{
        title: 'Stäng',
        callback: () => {
          dialog.close();
        }
      }]
    });
    svs.ui.dialog.api.add(dialog);
  }
});

 })(window);